/**
 * Marks a placeholder case study on screen, so an invented client and invented numbers are
 * never read as a real result. See lib/data/case-studies.ts.
 */
export default function IllustrativeBadge({ className = "" }: { className?: string }) {
  return (
    <span
      className={`inline-flex items-center rounded-full border border-amber-500/40 bg-amber-50 px-2.5 py-0.5 text-xs font-semibold text-amber-800 ${className}`}
    >
      Illustrative example
    </span>
  );
}
